export const defaultPayloadMapping = {
  sourceField: "",
  targetField: "",
  targetType: "attribute",
  isRequired: false,
  defaultValue: "",
} as const;
